import { clock, dur, hrs, istHM, useTick } from "../lib/time";
import { ClientChip, Switch } from "./bits";

const LABEL = { running: "Live", break: "On break", idle: "Idle", off: "Off", leave: "On leave" };

function Presence({ p }) {
  const t = useTick(1000);
  let extra = "";
  if (p.kind === "running" || p.kind === "break") extra = clock(t - p.since);
  else if (p.kind === "idle" && p.since) extra = `since ${istHM(p.since)}`;
  return (
    <span className={`pres pres-${p.kind}`}>
      <i className="dot" />{LABEL[p.kind]} {extra && <b className="mono">{extra}</b>}
    </span>
  );
}

function Load({ load, logged, isToday }) {
  const pct = Math.min(100, (load.fixed / load.cap) * 100);
  const over = load.fixed - load.cap;
  const free = load.cap - load.fixed;
  return (
    <div className="load" title={`${hrs(load.fixed)} of ${hrs(load.cap)} planned`}>
      <div className="load-bar"><div className={`load-fill ${load.over ? "over" : ""}`} style={{ width: `${pct}%` }} /></div>
      <div className="load-txt"><span className={`num ${load.over ? "t-danger" : ""}`}>{hrs(load.fixed)} / {hrs(load.cap)}{over > 0.01 ? ` +${hrs(over)}` : ""}</span>
        <span className="num">{isToday ? `${dur(logged)} logged` : free > 0 ? `${hrs(free)} free` : ""}</span></div>
    </div>
  );
}

export function PersonCell({ row, onLeave, onBack, names = {}, isToday = true, live }) {
  const p = row.person;
  return (
    <div className="pcell" data-testid={`person-${p.id}`}>
      <div className="pc-top"><span className="pc-av" aria-hidden="true">{p.name.split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase()}</span>
        <div><div className="pname">{p.name}</div><div className="pdesig">{p.designation}</div></div></div>
      {row.away ? <span className="pres pres-leave"><i className="dot" />{row.away.roster ? "Not on the roster" : "On leave"}</span>
        : isToday && (live ? <span className="pres pres-running"><ClientChip code={live.client} name={names[live.client]} /> <span className="trunc">{live.title}</span></span> : <Presence p={row.presence} />)}
      <Load load={row.load} logged={row.loggedTodayMs} isToday={isToday} />
      {!row.away?.roster && <label className="pc-leave"><Switch checked={!!row.away} label={`${p.short} on leave`} onChange={(v) => (v ? onLeave() : onBack())} testid={`leave-${p.id}`} /> On leave</label>}
    </div>
  );
}
